import {Component, Input} from '@angular/core';
import {ChartData, ChartDataset, ChartOptions, ChartType} from 'chart.js';
import {MarketSharesStudy} from '../market-shares-study';

@Component({
    selector: 'kiwi-product-market-shares',
    templateUrl: './product-market-shares.component.html',
    styleUrls: ['./product-market-shares.component.scss'],
    host: { 'class': 'cell auto grid-y' },
    standalone: false
})
export class ProductMarketSharesComponent {
    @Input()
    set marketShares(study: MarketSharesStudy) {
        this._marketShares = study;
        if (study) {
            this.pieChartDataInCovers = this.toPieData(study.marketSharesInCovers.chartDataSets);
            this.pieChartDataInTurnover = this.toPieData(study.marketSharesInTurnover.chartDataSets);
        }
    }

    get marketShares(): MarketSharesStudy {
        return this._marketShares;
    }

    private _marketShares: MarketSharesStudy;

    public pieChartType: ChartType = 'pie';
    public pieChartLegend = true;
    public chartColors: Array<string> = [
        'rgba(145, 79, 56, 1)',
        'rgba(192, 117, 91, 1)',
        'rgba(180,173,173, 1)',
        'rgba(90, 94, 107, 1)',
        'rgba(218, 143, 107, 1)',
        'rgba(192, 197, 193, 1)',
        'rgba(247, 227, 175, 1)',
        'rgba(39, 40, 56, 1)',
        'rgba(209, 157, 137, 1)',
        'rgba(98, 48, 24, 1)',
    ];

    public pieChartOptions: ChartOptions = {
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    font: {
                        size: 14
                    }
                }
            }
        }
    };

    public pieChartDataInCovers: ChartData;
    public pieChartDataInTurnover: ChartData;

    private toPieData(datasets: Array<ChartDataset>): ChartData {
        const mergedDataset: ChartDataset = {
            data: [],
            backgroundColor: this.chartColors
        };
        const mergedLabels: Array<string> = [];

        datasets.forEach(dataset => {
            mergedDataset.data.push(...dataset.data);
            mergedLabels.push(dataset.label);
        });

        return {
            labels: mergedLabels,
            datasets: [mergedDataset]
        };
    }
}
